import VueRouter from "vue-router";
import RouterView from "@/views/RouterView.vue";
//防止路由重复报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    mode: "hash",
    // mode: "history",
    routes: [
        {
            path: "/",
            component: RouterView,
            children: [
                {
                    path: "/",
                    component: () => import("@/views/home/Main.vue"),
                    redirect: "/",
                    children: [
                        // {
                        //     path: "/",
                        //     component: () => import("@/views/home/homePage/addProduct.vue"),
                        //     meta: {
                        //         title: "首页",
                        //         keepAlive: true,
                        //         id: 1
                        //     }
                        // },
                        {
                            path: "/",
                            component: () => import("@/views/home/homePage/Dashboard.vue"),
                            meta: {
                                title: "控制台",
                                keepAlive: true,
                                id: 1
                            }
                        },
                        {
                            path: "/addProduct",
                            component: () => import("@/views/home/homePage/addProduct.vue"),
                            meta: {
                                title: "编辑产品",
                                keepAlive: true,
                                id: 1
                            }
                        },
                        {
                            path: "/signup",
                            component: () => import("@/views/home/homePage/Signup.vue"),
                            meta: {
                                title: "注册",
                                keepAlive: true,
                                id: 1
                            }
                        },
                        {
                            path: "/order",
                            component: () => import("@/views/home/homePage/order.vue"),
                            meta: {
                                title: "订单",
                                keepAlive: true,
                                id: 1
                            }
                        },
                        {
                            path: "/oderDetails",
                            component: () => import("@/views/home/homePage/oderDetails.vue"),
                            meta: {
                                title: "订单详情",
                                keepAlive: false,
                                id: 1
                            }
                        }
                    ],
                    meta: {
                        title: "首页",
                        keepAlive: true,
                        fatherRoute: "/home",
                        id: 1
                    }
                }
            ]
        }, {
            path: "/settings",
            component: RouterView,
            redirect: "/settings",
            children: [{
                path: "/settings",
                component: () => import("@/views/home/settingPage/Main.vue"),
                redirect: "/settings",
                children: [{
                    path: "/settings/account",
                    component: () => import("@/views/home/settingPage/Settings.vue"),
                    meta: {
                        title: "控制台",
                        keepAlive: true,
                        id: 1
                    }
                }]
            }]
        },
        {
            path: "/agreement",
            component: () => import("@/views/home/homePage/agreement.vue"),
            children: [
                {
                    path: "/agreement",
                    component: () => import("@/views/home/homePage/agreement.vue"),
                    meta: {
                        title: "首页",
                        keepAlive: true,
                        fatherRoute: "/agreement",
                        id: 1
                    }
                }]
        }
    ]
})
router.beforeEach((to, from, next) => {
    console.log(window.localStorage.getItem('token'), to.path)
    if (to.path == '/' || to.path == '/signup' || to.path == '/agreement') {
        next()
    } else {
        if (window.localStorage.getItem('token')) {
            next()
        } else {
            next('/')
        }
    }

})
export default router
